// @flow

// Constants
import { BRANCH } from 'hfty-model-supplies'

export default {
  [BRANCH]: {},
}
